var _g, _path, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 194,
    height: 85,
    viewBox: "0 0 194 85",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_110_1109",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 94,
    height: 85
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_110_1109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.6441 54.2466L90.5584 54.2038C89.6409 53.7243 88.5519 54.2038 88.2089 55.1884C87.54 57.1233 86.1681 58.8527 84.0844 59.9401L50.5569 77.4914C48.0702 78.8014 45.0948 78.8014 42.5995 77.4914L9.07208 59.9401C6.9884 58.8527 5.61644 57.1233 4.9476 55.1884C4.61319 54.2123 3.51561 53.7243 2.59811 54.2038L2.51236 54.2466C-0.840383 56.0017 -0.840383 60.7877 2.51236 62.5428L44.3917 84.4692C45.7551 85.1798 47.3843 85.1798 48.7477 84.4692L90.6355 62.5428C93.9883 60.7877 93.9883 56.0017 90.6355 54.2466H90.6441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6441 38.5188L90.5584 38.476C89.6409 37.9966 88.5519 38.476 88.2089 39.4606C87.5401 41.3955 86.1681 43.125 84.0844 44.2123L50.557 61.7637C48.0703 63.0736 45.0948 63.0736 42.5996 61.7637L9.06353 44.2123C6.97986 43.125 5.60789 41.3955 4.93906 39.4606C4.60464 38.4846 3.50707 37.9966 2.58956 38.476L2.50382 38.5188C-0.848928 40.274 -0.848928 45.0599 2.50382 46.8151L44.3831 68.7414C45.7465 69.4521 47.3757 69.4521 48.7391 68.7414L90.627 46.8151C93.9797 45.0599 93.9797 40.274 90.627 38.5188H90.6441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.51236 30.7535L5.45352 32.286L10.1439 34.7432L19.2075 39.4778L24.9697 42.5L45.4035 53.185C46.1409 53.5703 47.0241 53.5703 47.7616 53.185L54.1926 49.8203C57.5454 48.0651 57.5454 43.2792 54.1926 41.524L40.5073 34.3579L34.745 31.3442L33.5874 30.7364C30.3633 29.0411 30.2432 24.5463 33.2273 22.6542C33.3387 22.5771 33.4674 22.5086 33.5874 22.4401L52.8721 12.3459L57.8369 9.75176C59.6462 8.80142 59.6462 6.2158 57.8369 5.27402L48.7562 0.539432C47.3928 -0.171184 45.7636 -0.171184 44.4002 0.539432L2.51236 22.4572C-0.840383 24.2038 -0.840383 28.9983 2.51236 30.7535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9889 22.4572C50.2568 23.3647 49.4165 25.0856 49.4851 26.7808C49.5451 28.3476 50.3769 29.8801 51.9632 30.7363C51.9718 30.7363 51.9804 30.7449 51.9889 30.7534L69.1299 39.726C69.1299 39.726 69.1471 39.726 69.1557 39.7346C70.5019 40.4452 72.114 40.4452 73.4688 39.7346C73.4688 39.7346 73.4859 39.7346 73.4945 39.726L73.949 39.4863L83.0125 34.7346L87.7029 32.286L90.6441 30.7534C90.6441 30.7534 90.6612 30.7449 90.6698 30.7363C93.9968 28.9726 93.9883 24.2038 90.6441 22.4572L73.4945 13.476C73.4345 13.4503 73.383 13.4161 73.3144 13.3904C73.2887 13.3733 73.263 13.3647 73.2373 13.3476C72.0368 12.714 70.5962 12.714 69.3958 13.3476C69.3958 13.3476 69.3357 13.3733 69.3186 13.3904C69.2586 13.4161 69.1985 13.4503 69.1385 13.476L62.0729 17.1747L55.7704 20.4795L51.9975 22.4572H51.9889Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_110_1109)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.8738 -2.14642H-1.28784V86.7172H94.8738V-2.14642Z",
    fill: "url(#paint0_linear_110_1109)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49,
    d: "M38.0354 70.7582C61.3889 70.7582 80.3207 51.8264 80.3207 28.4729C80.3207 5.11933 61.3889 -13.8125 38.0354 -13.8125C14.6818 -13.8125 -4.25 5.11933 -4.25 28.4729C-4.25 51.8264 14.6818 70.7582 38.0354 70.7582Z",
    fill: "url(#paint1_radial_110_1109)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_110_1109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.156 70.6563V12.8209H121.929V62.9803H143.358V70.6563H113.156Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.301 70.6563V12.8209H180.851V20.3284H158.073V38.2862H177.986V45.8735H158.073V70.6563H149.301Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.445 20.3373V12.75H193.375V20.3373H185.445ZM185.445 70.6563V26.3114H193.375V70.6563H185.445Z",
    fill: "#E8E8E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_110_1109",
    x1: -1.28784,
    y1: 42.2854,
    x2: 94.8738,
    y2: 42.2854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#0066B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828487"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_110_1109",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.0354 28.4729) scale(42.2854)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828487",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_1109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.1566,
    height: 85,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_110_1109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.2188,
    height: 57.9063,
    fill: "white",
    transform: "translate(113.156 12.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSm);
export default __webpack_public_path__ + "static/media/logo-sm.16b40420b980650575406381c600b770.svg";
export { ForwardRef as ReactComponent };